"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomXPFieldsContent = exports.CustomXPFieldsHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.CustomXPFieldsHeader = styled_1.default.h2 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
`;
exports.CustomXPFieldsContent = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
//# sourceMappingURL=styles.js.map